export enum TierType {
  FreeTier = 'tenant:free-tier',
  BuilderTier = 'builder-tier'
}
